import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class VaultResAddTokenSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken, pan, expdate } = this.props;
         return (
            <pre className="sampleCode">
{
`namespace Moneris
{
using System;
using System.Text;
using System.Collections; public class TestCanadaResAddCC {
public static void Main(string[] args) {
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string pan = "`}{this.getValue(pan, "pan")}{`";
string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
string phone = "0000000000";
string email = "bob@smith.com"; 
string note = "my note";
string cust_id = "customer1";
string crypt_type = "7";
string data_key_format = "0";
string processing_country_code = "CA"; 
bool status_check = false;
AvsInfo avsCheck = new AvsInfo(); 
avsCheck.SetAvsStreetNumber("212"); 
avsCheck.SetAvsStreetName("Payton Street"); 
avsCheck.SetAvsZipCode("M1M1M1");
CofInfo cof = new CofInfo(); 
cof.SetIssuerId("168451306048014");
ResAddCC resaddcc = new ResAddCC(); 
resaddcc.SetPan(pan);
resaddcc.SetExpDate(expdate); 
resaddcc.SetCryptType(crypt_type); 
resaddcc.SetCustId(cust_id);
resaddcc.SetPhone(phone);
resaddcc.SetEmail(email);
resaddcc.SetNote(note);
resaddcc.SetAvsInfo(avsCheck); 
resaddcc.SetGetCardType("true"); 
//resaddcc.SetDataKeyFormat(data_key_format); //optional 
resaddcc.SetCofInfo(cof);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions 
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token);
mpgReq.SetTransaction(resaddcc);
mpgReq.SetStatusCheck(status_check);
mpgReq.Send();
try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("DataKey = " + receipt.GetDataKey()); 
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode()); 
Console.WriteLine("Message = " + receipt.GetMessage());
Console.WriteLine("TransDate = " + receipt.GetTransDate()); 
Console.WriteLine("TransTime = " + receipt.GetTransTime()); 
Console.WriteLine("Complete = " + receipt.GetComplete());
Console.WriteLine("TimedOut = " + receipt.GetTimedOut()); 
Console.WriteLine("ResSuccess = " + receipt.GetResSuccess()); 
Console.WriteLine("PaymentType = " + receipt.GetPaymentType()); 
Console.WriteLine("Cust ID = " + receipt.GetResDataCustId()); 
Console.WriteLine("Phone = " + receipt.GetResDataPhone());
Console.WriteLine("Email = " + receipt.GetResDataEmail());
Console.WriteLine("Note = " + receipt.GetResDataNote());
Console.WriteLine("MaskedPan = " + receipt.GetResDataMaskedPan()); 
Console.WriteLine("Exp Date = " + receipt.GetResDataExpdate()); 
Console.WriteLine("Crypt Type = " + receipt.GetResDataCryptType()); 
Console.WriteLine("Avs Street Number = " + receipt.GetResDataAvsStreetNumber()); 
Console.WriteLine("Avs Street Name = " + receipt.GetResDataAvsStreetName()); 
Console.WriteLine("Avs Zipcode = " + receipt.GetResDataAvsZipcode()); 
Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
Console.ReadLine();
}
catch (Exception e) { Console.WriteLine(e); }
} 
} 
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, pan, expdate } = this.props;
        return (
            <pre className="sampleCode">
{
`
public class TestCanadaResAddCC
{
public static void main(String[] args) {
String store_id = "`}{this.getValue(storeId, "storeId")}{`";
String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
String pan = "`}{this.getValue(pan, "pan")}{`";
String expiry_date =  "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
String phone = "0000000000";
String email = "bob@smith.com"; 
String note = "my note";
String cust_id = "customer1";
String crypt_type = "7";
String data_key_format = "0";
String processing_country_code = "CA"; 
boolean status_check = false;
AvsInfo avsCheck = new AvsInfo(); 
avsCheck.setAvsStreetNumber("212"); 
avsCheck.setAvsStreetName("Payton Street"); 
avsCheck.setAvsZipCode("M1M1M1");
ResAddCC resaddcc = new ResAddCC(); 
resaddcc.setPan(pan);
resaddcc.setExpdate(expdate); 
resaddcc.setCryptType(crypt_type); 
resaddcc.setCustId(cust_id);
resaddcc.setPhone(phone);
resaddcc.setEmail(email);
resaddcc.setNote(note);
resaddcc.setAvsInfo(avsCheck); 
//resaddcc.setDataKeyFormat(data_key_format); //optional 
//Mandatory - Credential on File details
CofInfo cof = new CofInfo();
cof.setIssuerId("139X3130ASCXAS9"); //can be obtained by performing card verification
resaddcc.setCofInfo(cof);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions 
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(resaddcc);
mpgReq.setStatusCheck(status_check);
mpgReq.send();
try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("DataKey = " + receipt.getDataKey()); 
System.out.println("ResponseCode = " + receipt.getResponseCode()); 
System.out.println("Message = " + receipt.getMessage()); 
System.out.println("TransDate = " + receipt.getTransDate()); 
System.out.println("TransTime = " + receipt.getTransTime()); 
System.out.println("Complete = " + receipt.getComplete()); 
System.out.println("TimedOut = " + receipt.getTimedOut()); 
System.out.println("ResSuccess = " + receipt.getResSuccess()); 
System.out.println("PaymentType = " + receipt.getPaymentType()); 
System.out.println("Cust ID = " + receipt.getResCustId());
System.out.println("Phone = " + receipt.getResPhone());
System.out.println("Email = " + receipt.getResEmail());
System.out.println("Note = " + receipt.getResNote());
System.out.println("MaskedPan = " + receipt.getResMaskedPan()); 
System.out.println("Exp Date = " + receipt.getResExpdate()); 
System.out.println("Crypt Type = " + receipt.getResCryptType()); 
System.out.println("Avs Street Number = " + receipt.getResAvsStreetNumber()); 
System.out.println("Avs Street Name = " + receipt.getResAvsStreetName());
System.out.println("Avs Zipcode = " + receipt.getResAvsZipcode()); 
System.out.println("IssuerId = " + receipt.getIssuerId());
}
catch (Exception e)
{
e.printStackTrace(); 
}
}
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, pan, expdate } = this.props;

        return (
            <pre className="sampleCode">
{
`<?php
##
## Example php -q TestResAddCC.php store3 yesguy
##
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/ 
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************* Transactional Variables ****************************/
$type='res_add_cc';
$phone = '5555551234';
$email = 'bob@smith.com';
$note = 'this is my note';
'pan'=>`}{this.getValue(pan, "pan")}{`,
$expiryDate =>'`}{this.getValue(expdate, "expdate")}{`';
$crypt_type='1';
$data_key_format = "0";
$avs_street_number = '123';
$avs_street_name = 'lakeshore blvd';
$avs_zipcode = '90210';
/*********************** Transactional Associative Array **********************/ $txnArray=array('type'=>$type,
'cust_id'=>$cust_id,
'phone'=>$phone,
'email'=>$email,
'note'=>$note,
'pan'=>$pan,
'expdate'=>$expiry_date, //'data_key_format'=>$data_key_format, //optional 'crypt_type'=>$crypt_type
);
/********************** AVS Associative Array *********************************/ $avsTemplate = array(
'avs_street_number' => $avs_street_number,
'avs_street_name' => $avs_street_name,
'avs_zipcode' => $avs_zipcode
);
/************************** AVS Object ***************************************/
$mpgAvsInfo = new mpgAvsInfo ($avsTemplate);
/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setIssuerId("139X3130ASCXAS9");
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
$mpgTxn->setAvsInfo($mpgAvsInfo);
$mpgTxn->setCofInfo($cof);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment $mpgRequest->setTestMode(true); //false or comment out this line for production transactions /***************************** HTTPS Post Object *****************************/ $mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest); /******************************* Response ************************************/ $mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nResSuccess = " . $mpgResponse->getResSuccess());
print("\\nPaymentType = " . $mpgResponse->getPaymentType());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
//----------------- ResolveData ------------------------------
print("\\n\\nCust ID = " . $mpgResponse->getResDataCustId());
print("\\nPhone = " . $mpgResponse->getResDataPhone());
print("\\nEmail = " . $mpgResponse->getResDataEmail());
print("\\nNote = " . $mpgResponse->getResDataNote());
print("\\nMasked Pan = " . $mpgResponse->getResDataMaskedPan());
print("\\nExp Date = " . $mpgResponse->getResDataExpDate());
print("\\nCrypt Type = " . $mpgResponse->getResDataCryptType()); 
print("\\nAvs Street Number = " . $mpgResponse->getResDataAvsStreetNumber()); 
print("\\nAvs Street Name = " . $mpgResponse->getResDataAvsStreetName()); 
print("\\nAvs Zipcode = " . $mpgResponse->getResDataAvsZipcode());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { purchaseSuccess,purchaseResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, onEditId} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, onEditId, loading, progLangId: state.common.progLangList.selection,purchaseSuccess,purchaseResponse };
  }
  
  export default connect(mapStateToProps, {})(VaultResAddTokenSample)